import { ComponentProps } from 'react';

import DimmableCard from '../../../components/DimmableCard/DimmableCard';
import useForm from '../../../components/Form/hooks/useForm';

type FormDimmableCardProps = ComponentProps<typeof DimmableCard>;

const FormDimmableCard = ({ dimmed, ...otherProps }: FormDimmableCardProps) => {
    const { submitting } = useForm();

    return <DimmableCard {...otherProps} dimmed={dimmed || submitting} />;
};

export default FormDimmableCard;
